import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalTitle,
} from "react-bootstrap";
import { connect } from "react-redux";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import {
    AddDocuments,
    DeleteDocument,
    GetInfo,
} from "../../redux/actions/auth";
import { START_LOADER, STOP_LOADER } from "../../redux/actions/types";

const Documents = ({
    startLoading,
    stopLoading,
    user,
    addDocs,
    deleteDoc,
    getInfo,
}) => {
    const [addDocModal, setAddDocModal] = useState(false);
    const [docs, setDocs] = useState([]);

    const deleteDocFn = async (id) => {
        await deleteDoc(id);
    };

    const addDocsFn = async () => {
        setAddDocModal(false);
        await addDocs(docs);
    };

    const getUser = async () => {
        startLoading();
        await getInfo();
        stopLoading();
    };

    useEffect(() => {
        getUser();
    }, []);

    return (
        <>
            <Header />
            <div className="care-registration">
                <div className="container">
                    <div className="top_bar">
                        <div className="heading_wrapper">
                            <h2>Documents</h2>
                            <p>
                                Manage all your documents on the go with ease
                                and comfort.
                            </p>
                        </div>
                    </div>
                    <div id="wizard">
                        <section id="tabcontent" className="second_tab">
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => setAddDocModal(true)}
                            >
                                Add Documment
                            </button>
                            <a
                                href="/agreements/hold_harmless.pdf"
                                className="btn btn-danger text-white ml-2"
                                download
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                &nbsp; Hold Harmless Agreemennt
                            </a>
                            <a
                                href="/agreements/photo_release.pdf"
                                className="btn btn-danger text-white ml-2"
                                download
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                &nbsp; Photo Release Agreemennt
                            </a>

                            <div className="mt-3">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Document</th>
                                            <th scope="col">Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {user?.documents?.map((doc) => (
                                            <tr key={doc.id}>
                                                <td>{doc.document}</td>
                                                <td
                                                    onClick={() =>
                                                        deleteDocFn(doc.id)
                                                    }
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    Delete
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </section>

                        <div className="bottom_bar">
                            <div className="note">
                                <p>
                                    Note: service providers (e.g. sitters) must
                                    abide by applicable laws and regulations.{" "}
                                    <a href="#" style={{ color: "#000" }}>
                                        Terms of Service
                                    </a>
                                </p>
                            </div>
                            {/* <div className="button-group">
                    <button className="btn">Cancel</button>
                    <button className="btn ml-2"
                     onClick={()=>Navigate('/care-giver-registration3')}
                    >Save Changes</button>
                </div>  */}
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                onHide={() => setAddDocModal(false)}
                show={addDocModal}
                size="lg"
            >
                <ModalHeader closeButton={true}>
                    <ModalTitle>Add Documments</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="form-group">
                        <label>Documennts</label>
                        <input
                            className="form-control"
                            type={"file"}
                            multiple
                            onChange={(e) => setDocs(e.target.files)}
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => setAddDocModal(false)}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={addDocsFn}
                    >
                        Save
                    </button>
                </ModalFooter>
            </Modal>
            <Footer />
        </>
    );
};

const mmapStateToProps = (state) => ({
    user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
    startLoading: () => dispatch({ type: START_LOADER }),
    stopLoading: () => dispatch({ type: STOP_LOADER }),
    addDocs: (docs) => dispatch(AddDocuments(docs)),
    deleteDoc: (doc_id) => dispatch(DeleteDocument(doc_id)),
    getInfo: () => dispatch(GetInfo()),
});

export default connect(mmapStateToProps, mapDispatchToProps)(Documents);
